import type { FormOptions } from '@customTypes/types';

export const helpWithOptions: FormOptions = {
  userManagement: 'User management',
  deviceManagement: 'Device management',
  workspaceManagement: 'Workspace management',
  applicationProvisioning: 'Application provisioning',
  subscriptionManagement: 'Subscription management',
  api: 'HPE GreenLake Platform APIs Onboarding',
  // commerceApi: 'Commerce API - Partner Access Request',
  serviceDeliveryInformation: 'Service delivery information (SDI)',
  // localGateway: 'Local Gateway',
  // newSubscriptionOrder: 'New subscription order',
  supportHub: 'Support Hub',
  other: 'Other',
};

export const localGatewayOptions: string[] = [
  'OVA download and install',
  'Registration token',
  'Configuration assistance',
  'Gateway user management',
  'Gateway appliance cloud connectivity',
  'Other',
];
